import React from 'react';
interface TermsPageProps {
  onBack: () => void;
}
export function TermsPage({
  onBack
}: TermsPageProps) {
  return <div className="min-h-screen bg-[#1E1B19] font-sans" data-id="element-82">
      <nav className="py-6 px-6 text-center border-b border-[#3A3330]" data-id="element-83">
        <div className="font-serif text-2xl font-bold text-[#F5F0EB] tracking-tight" data-id="element-84">
          El Método del <span className="text-[#C5A55A]" data-id="element-85">Látex</span>
        </div>
      </nav>

      <main className="max-w-2xl mx-auto px-6 py-16" data-id="element-86">
        <button onClick={onBack} className="text-[#C5A55A] text-sm font-medium mb-8 inline-flex items-center gap-1 hover:text-[#D4B96A] transition-colors" data-id="element-87">
          ← Volver a la página principal
        </button>

        <h1 className="font-serif text-3xl md:text-4xl font-bold text-[#F5F0EB] mb-10" data-id="element-88">
          Términos y Condiciones
        </h1>

        <div className="space-y-8 text-[#A89B8C] leading-relaxed" data-id="element-89">
          <section data-id="element-90">
            <h2 className="font-serif text-xl font-bold text-[#F5F0EB] mb-3" data-id="element-91">
              1. Aceptación de los Términos
            </h2>
            <p data-id="element-92">
              Al adquirir y/o utilizar el producto digital "El Método del Látex"
              (en adelante, "el Producto"), usted acepta en su totalidad los
              presentes Términos y Condiciones. Si no está de acuerdo con alguno
              de estos términos, le solicitamos no realizar la compra.
            </p>
          </section>

          <section data-id="element-93">
            <h2 className="font-serif text-xl font-bold text-[#F5F0EB] mb-3" data-id="element-94">
              2. Descripción del Producto
            </h2>
            <p data-id="element-95">
              El Producto consiste en un libro digital (ebook) en formato PDF
              que contiene un programa de entrenamiento práctico de 21 días
              enfocado en técnicas de microblading sobre superficies de látex.
              El contenido es exclusivamente educativo y de práctica.
            </p>
          </section>

          <section data-id="element-96">
            <h2 className="font-serif text-xl font-bold text-[#F5F0EB] mb-3" data-id="element-97">
              3. Licencia de Uso
            </h2>
            <p data-id="element-98">
              Al completar su compra, usted recibe una licencia personal,
              intransferible y no exclusiva para usar el Producto. Queda
              estrictamente prohibido:
            </p>
            <ul className="list-disc pl-6 mt-3 space-y-2" data-id="element-99">
              <li data-id="element-100">
                Reproducir, distribuir o compartir el contenido total o
                parcialmente.
              </li>
              <li data-id="element-101">Revender, sublicenciar o comercializar el Producto.</li>
              <li data-id="element-102">
                Modificar el contenido para crear obras derivadas con fines
                comerciales.
              </li>
            </ul>
          </section>

          <section data-id="element-103">
            <h2 className="font-serif text-xl font-bold text-[#F5F0EB] mb-3" data-id="element-104">
              4. Política de Reembolso
            </h2>
            <p data-id="element-105">
              Ofrecemos una garantía de satisfacción de 30 días naturales a
              partir de la fecha de compra. Si el Producto no cumple con sus
              expectativas, puede solicitar un reembolso completo dentro de
              dicho plazo. Pasados los 30 días, no se aceptarán solicitudes de
              devolución.
            </p>
          </section>

          <section data-id="element-106">
            <h2 className="font-serif text-xl font-bold text-[#F5F0EB] mb-3" data-id="element-107">
              5. Propiedad Intelectual
            </h2>
            <p data-id="element-108">
              Todo el contenido del Producto — incluyendo textos, imágenes,
              diagramas, ejercicios y metodologías — está protegido por las
              leyes de propiedad intelectual y derechos de autor. La compra del
              Producto no transfiere ningún derecho de propiedad intelectual al
              comprador.
            </p>
          </section>

          <section data-id="element-109">
            <h2 className="font-serif text-xl font-bold text-[#F5F0EB] mb-3" data-id="element-110">
              6. Limitación de Responsabilidad
            </h2>
            <p data-id="element-111">
              El Producto tiene fines exclusivamente educativos y de práctica
              sobre materiales sintéticos (látex). No sustituye formación
              profesional certificada ni autoriza la práctica de microblading en
              piel humana. El uso que el comprador haga de la información es
              bajo su propia responsabilidad.
            </p>
            <p className="mt-3" data-id="element-112">
              No nos hacemos responsables de resultados derivados de la
              aplicación de las técnicas descritas en personas reales sin la
              debida certificación y supervisión profesional.
            </p>
          </section>

          <section data-id="element-113">
            <h2 className="font-serif text-xl font-bold text-[#F5F0EB] mb-3" data-id="element-114">
              7. Entrega del Producto
            </h2>
            <p data-id="element-115">
              El Producto se entrega en formato digital (PDF) de forma inmediata
              tras la confirmación del pago. El acceso se proporciona mediante
              enlace de descarga enviado al correo electrónico proporcionado
              durante la compra.
            </p>
          </section>

          <section data-id="element-116">
            <h2 className="font-serif text-xl font-bold text-[#F5F0EB] mb-3" data-id="element-117">
              8. Privacidad y Datos Personales
            </h2>
            <p data-id="element-118">
              Los datos personales recopilados durante el proceso de compra
              (nombre y correo electrónico) se utilizan exclusivamente para la
              entrega del Producto y comunicaciones relacionadas. No
              compartimos, vendemos ni cedemos información personal a terceros.
            </p>
          </section>

          <section data-id="element-119">
            <h2 className="font-serif text-xl font-bold text-[#F5F0EB] mb-3" data-id="element-120">
              9. Modificaciones
            </h2>
            <p data-id="element-121">
              Nos reservamos el derecho de modificar estos Términos y
              Condiciones en cualquier momento. Las modificaciones entrarán en
              vigor desde su publicación. El uso continuado del Producto tras
              cualquier modificación constituye la aceptación de los nuevos
              términos.
            </p>
          </section>

          <section className="pt-4 border-t border-[#3A3330]" data-id="element-122">
            <p className="text-sm text-[#7A6F64]" data-id="element-123">
              Última actualización:{' '}
              {new Date().toLocaleDateString('es-ES', {
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            })}
            </p>
          </section>
        </div>
      </main>
    </div>;
}